<template>
  <div
    style="font-family: Titillium Web; line-height: 1; background: black"
    class="
      p-3
      ml-1
      mr-1
      bg-white
      shadow-lg
      rounded-lg
      animate__animated animate__bounceInRight
    "
  >
    <br />
    <div id="atas"></div>
    <a href="https://github.com/AkbarMaliki">
      <button
        type="button"
        class="btn btn-sm btn-style9 float-right"
        style="
          margin-left: 5px;
          padding: 3px;
          padding-top: 0px;
          padding-bottom: 0px;
          background: rgb(11, 1, 1);
          background: linear-gradient(
            90deg,
            rgba(11, 1, 1, 0.7203256302521008) 3%,
            rgba(6, 1, 1, 0.7791491596638656) 99%
          );
        "
      >
        <img
          src="https://upload.egov.balangankab.go.id/svg/social-github-circular.svg"
          class="d-inline"
          style="height: 20px; width: 20px; filter: brightness(0) invert(1)"
          alt=""
        />
      </button>
    </a>
    <a href="https://www.linkedin.com/in/taufik-akbar-maliki-405520168/">
      <button
        type="button"
        class="btn btn-sm btn-style9 float-right"
        style="
          margin-left: 5px;
          padding: 3px;
          padding-top: 0px;
          padding-bottom: 0px;
          background: rgb(11, 1, 1);
          background: linear-gradient(
            90deg,
            rgba(11, 1, 1, 0.7203256302521008) 3%,
            rgba(6, 1, 1, 0.7791491596638656) 99%
          );
        "
      >
        <img
          src="https://upload.egov.balangankab.go.id/svg/social-linkedin-circular.svg"
          class="d-inline"
          style="height: 20px; width: 20px; filter: brightness(0) invert(1)"
          alt=""
        />
      </button>
    </a>
    <a href="https://www.instagram.com/ta.maliki/">
      <button
        type="button"
        class="btn btn-sm btn-style9 float-right"
        style="
          margin-left: 5px;
          padding: 3px;
          padding-top: 0px;
          padding-bottom: 0px;
          background: rgb(11, 1, 1);
          background: linear-gradient(
            90deg,
            rgba(11, 1, 1, 0.7203256302521008) 3%,
            rgba(6, 1, 1, 0.7791491596638656) 99%
          );
        "
      >
        <img
          src="https://upload.egov.balangankab.go.id/svg/social-instagram.svg"
          class="d-inline"
          style="height: 20px; width: 20px; filter: brightness(0) invert(1)"
          alt=""
        />
      </button>
    </a>
    <a href="https://www.facebook.com/malik.pleiades/">
      <button
        type="button"
        class="btn btn-sm btn-style9 float-right"
        style="
          margin-left: 5px;
          padding: 3px;
          padding-top: 0px;
          padding-bottom: 0px;
          background: rgb(11, 1, 1);
          background: linear-gradient(
            90deg,
            rgba(11, 1, 1, 0.7203256302521008) 3%,
            rgba(6, 1, 1, 0.7791491596638656) 99%
          );
        "
      >
        <img
          src="https://upload.egov.balangankab.go.id/svg/social-facebook.svg"
          class="d-inline"
          style="height: 20px; width: 20px; filter: brightness(0) invert(1)"
          alt=""
        />
      </button>
    </a>
    <!-- <p class="pl-3 font-bold  text-lg underline italic">{{datanya.judul}}</p> -->
    <p class="pl-3 font-bold text-2xl">{{ datanya.judul }}</p>
    <!-- <span class="float-right italic font-bold ">{{datanya.createdAt.toDate()}}</span> -->
    <div class="pl-3 pr-3">
      <hr class="style4 mt-4 mb-4" />
      <br />
    </div>
    <div style="line-height: 1.5" class="p-3 rounded-lg text-lg">
      <img
        :src="datanya.gambar"
        v-viewer
        class="kinoLightBox img-thumbnail mx-auto shadow-lg rounded-lg"
        style="height: 400px"
      />
      <div v-html="datanya.keterangan"></div>

      <br />
      <p class="p-3 font-bold italic float-right" v-show="datanya.link">
        Link : {{ datanya.link }}
      </p>
      <p class="p-3 font-bold italic float-right" v-show="datanya.video">
        Video : {{ datanya.video }}
      </p>
      <p class="p-3 font-bold italic float-right">
        Teknologi : {{ datanya.framework }}
      </p>
      <br />
      <br />
      <b> Hi cek sertifikat, keahlian, dan projectku yuk ! </b>
      <button
        type="button"
        class="btn btn-sm btn-style9 float-right underline italic"
        @click="$router.push('/portofolio')"
        style="
          background: rgb(11, 1, 1);
          background: linear-gradient(
            90deg,
            rgba(11, 1, 1, 0.7203256302521008) 3%,
            rgba(6, 1, 1, 0.7791491596638656) 99%
          );
        "
      >
        Check it out! <span class="typcn typcn-pencil"></span>
      </button>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import autophp from '~/plugins/autophp.js'
let sdb = new autophp()
import _ from 'lodash'
export default {
  layout: 'author',
  data() {
    return {
      buka: true,
      datanya: [],
    }
  },
  components: {},
  // asyncData({isDev, route, store, env, params, query, req, res, redirect, error}) {
  //   let datas = datanya;
  //     let data = route.params.id.split('-');
  //     let id = data[data.length-1];
  //     datas=datas.filter(e=>{
  //     if(e.id==id){
  //       return e;
  //     }
  //   })
  //   datas=datas[0];
  // return{
  //   datanya:datas
  // }
  // },
  mounted() {
    let data = this.$route.params.id.split('-')
    let id = data[data.length - 1]
    sdb
      .collection('portofolio')
      .doc()
      .select(`select * from portofolio where id='${id}'`)
      .then((res) => {
        console.log(res)
        this.datanya = res[0]
      })
  },
  methods: {
    geser() {
      this.buka = !this.buka
      this.$nuxt.$emit('buka', this.buka)
    },
  },

}
</script>